import { Injectable } from "@angular/core";
import { MICustomFunctionsParams } from "../../../models/fields/custom-function-params";

@Injectable({
    providedIn: 'root'
})

export class CommonFunctionService {

    constructor() {
    }


    sanitizeLink(customFunctionsObj: MICustomFunctionsParams) {
        var link = customFunctionsObj.item.formControl.value;
        if (!link) return;

        link = link.replace(/^(?:[a-zA-Z]+:\/{2}|\/{2})/, '');
        customFunctionsObj.item.formControl.setValue(link)
    }
}


